module.exports = __webpack_public_path__ + "img/watch.9d5d6e22.png";